import { axiosInstance } from "./index";
import { TokenStorage } from "./tokenStorage";
import type { User } from "./user";
import type { PaymentProfileInput } from "./creatorCpi";

export type LegalDocumentType = "terms_of_service" | "fee_schedule" | "privacy_policy";
export type CreatorInvitationTerminalReason = "expired" | "already_used" | "revoked";

export interface CreatorInvitationTerminalResponse {
	code: "INVITATION_EXPIRED" | "INVITATION_ALREADY_USED" | "INVITATION_REVOKED";
	reason: CreatorInvitationTerminalReason;
	message: string;
	expiredAt?: string;
	contactEmail?: string;
}

export const creatorInvitationApi = {
	resolve: async (
		token: string,
	): Promise<{ campaignName: string; accountState: "new" | "existing"; email?: string }> =>
		(await axiosInstance.get(`/creator-invitations/${encodeURIComponent(token)}`)).data,
	requestNewLink: async (token: string): Promise<void> => {
		await axiosInstance.post(`/creator-invitations/request-new-link/${encodeURIComponent(token)}`);
	},
	acceptLegalDocuments: async (documentTypes: LegalDocumentType[]): Promise<void> => {
		await axiosInstance.post("/users/legal-consents", { documentTypes });
	},
	register: async (
		token: string,
		payload: Record<string, unknown>,
	): Promise<{ user: User; accessToken: string; sessionExpiresAt?: string; campaignId?: string }> => {
		const response = await axiosInstance.post(
			`/creator-invitations/${encodeURIComponent(token)}/register`,
			payload,
		);
		TokenStorage.setAccessToken(response.data.accessToken);
		TokenStorage.setSessionExpiresAt(response.data.sessionExpiresAt);
		return response.data;
	},
	accept: async (
		token: string,
		paymentProfile?: PaymentProfileInput,
	): Promise<{ user: User; accessToken: string; sessionExpiresAt?: string; campaignId?: string }> => {
		const response = await axiosInstance.post(`/creator-invitations/${encodeURIComponent(token)}/accept`, {
			paymentProfile,
		});
		TokenStorage.setAccessToken(response.data.accessToken);
		TokenStorage.setSessionExpiresAt(response.data.sessionExpiresAt);
		return response.data;
	},
};
